import {danger} from "../../components/notifications";
import {getEncodedHtml} from "../../utils/helpers";

let profileContactDataIsFetched = false;
let profileContactInfoModal = null;

const initPage = () => {
  if (!$("#job-seeker-profile-view-page").length) {
    return;
  }

  initProfileInfoModal();
  initProfilePhotoModal();
};

const initProfileInfoModal = () => {
  profileContactInfoModal = $('#job-seeker-profile-contact-info-modal');
  if (!profileContactInfoModal) {
    return;
  }

  $("#show-contact-info-btn").click(function () {
    const profileId = $(this).data('profile-id');

    if (!profileId) {
      return;
    }

    handleModalErrorMessage();
    profileContactInfoModal.modal('show');

    if (!profileContactDataIsFetched) {
      $('#profile-info-modal-loader')?.loading(true);
      fetchProfileData(profileId);
    }
  });
}

const fetchProfileData = async profileId => {
  let response;
  try {
    response = await axios.get(`/api/profiles/${profileId}/contact_info`);
  } catch (e) {
    if (e.response.status === 403) {
      let errorMessage = e.response.data.message;
      handleModalErrorMessage(errorMessage);
    } else {
      danger(e.message);
      profileContactInfoModal.modal('hide');
    }
  }

  if (response) {
    fillTheData(response)
    profileContactDataIsFetched = true;
  }

  $('#profile-info-modal-loader')?.loading(false);
}

const fillTheData = profileData => {
  const contactInfoBody = $('#profile-data-container');

  if (!profileData.data || !contactInfoBody) {
    return;
  }

  profileData = profileData.data;

  const rowsOptions = [
    {
      key: 'email',
      icon: 'email',
      isAnchor: true,
    },
    {
      key: 'phone_number',
      icon: 'phone',
      isAnchor: false
    },
    {
      key: 'linkedin_url',
      icon: 'linkedin_logo',
      isAnchor: true
    }
  ];

  let notNullValuesCount = 0;

  for (let key in profileData) {
    if (profileData[key]) {
      notNullValuesCount++
    }
  }

  let i = 1;
  rowsOptions.forEach(options => {
    if (profileData[options.key]) {
      options.value = profileData[options.key];

      if (i === notNullValuesCount) {
        options.theLast = true;
      }

      i++;

      contactInfoBody.append(_renderContactInfoItems(options));
    }
  });

  //After unlocking contact info, display the full name of the job seeker.
  if (profileData['display_name']) {
    $('#job-seeker-profile-display-name').text(profileData['display_name']);
    $('#show-contact-info-btn .unlocked').removeClass('d-none');
    $('#show-contact-info-btn .locked').addClass('d-none');
    $('.profile-resume .unlocked').removeClass('d-none');
    $('.profile-resume .locked').addClass('d-none');
  }
}

const handleModalErrorMessage = (errorMessage = '') => {

  const errorRow = $('#profile_info_modal_error');
  const errorTextElement = $('.f_error-text', errorRow);
  if (!errorRow || !errorTextElement) {
    return;
  }

  if (errorMessage) {
    errorRow.show();
    errorTextElement.html(errorMessage);
  } else {
    errorRow.hide();
    errorTextElement.text('');
  }
}

const initProfilePhotoModal = () => {
  $('#profile-picture').click(function (e) {
    $('#modal-job-seeker-profile-photo').modal('show');
  })
}

const _renderContactInfoItems = (options) => {
  const value = getEncodedHtml(options.value);

  let icon = $(`#${options.key}_icon_reserved`);
  icon = icon.length ? icon.html() : '';

  let content = `<div class="pt-2 pb-2 d-flex align-items-center">${icon}`;

  if(options.isAnchor) {
    let hrefAttr = '';

    if(options.key === 'email') {
      hrefAttr = `href="mailto: ${value}"`;
    }else {
      hrefAttr = `href="${value}"`;
    }
    content += `<a ${hrefAttr} target="_blank" rel="noopener" class="pl-2 text-reset text-ellipsis-1 text-left">${value}</a>`;

  } else {
    content += `<span class="pl-2">${value}</span>`;
  }

  content += '</div>';

  return content;
}

$(initPage);
